import { render, staticRenderFns } from "./LuAgencyDivision-a-multi-join.vue?vue&type=template&id=67ad9195"
import script from "./LuAgencyDivision-a-multi-join.vue?vue&type=script&lang=js"
export * from "./LuAgencyDivision-a-multi-join.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports